<template>
  <v-card flat v-if="booking && !isBookingCancelled">
    <v-row align="center" justify="center">
      <v-col class="justify-center align-center text-center" cols="12">
        <v-card-text class="mt-4 text-h5 font-weight-bold"
          >{{ $t("bookingForm.BookingCancel.bookingCancel") }}
        </v-card-text>

        <booking-success
          heading="bookingForm.BookingDetail.yourCreatedBooking"
          :text="$t('bookingForm.BookingCancel.bookingCancelText', { serviceName: serviceName })"
          :showImage="false"
          :showDownloadBtn="false"
        />

        <v-card-text class="mt-n6 mb-8">
          <v-btn color="error" elevation="0" :block="isMobile" @click="cancel">
            {{ $t("bookingForm.BookingCancel.cancel") }}
          </v-btn>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
  <v-card flat v-else-if="isBookingCancelled">
    <booking-success
      :showDownloadBtn="false"
      :showImage="false"
      heading="bookingForm.BookingCancel.bookingCanceledHeading"
      text="bookingForm.BookingCancel.bookingCanceledSuccess"
    />
  </v-card>
  <error-card v-else />
</template>

<script lang="ts">
import ErrorCard from "@/components/utility/ErrorCard.vue";
import { detailedDateWithDay, formatHoursAndMinutes } from "@/lib/utility/date-helper";
import { BookingBookingUnauthenticatedViewModelGen } from "@/services/booking/v1/data-contracts";
import { Component, Prop, Vue } from "vue-property-decorator";
import BookingSuccess from "@/components/booking/customer/BookingSuccess.vue";

@Component({
  components: {
    ErrorCard,
    BookingSuccess
  }
})
export default class BookingCancel extends Vue {
  @Prop({ default: false })
  isMobile!: boolean;

  @Prop()
  bookingId!: string;

  @Prop()
  booking!: BookingBookingUnauthenticatedViewModelGen;

  @Prop()
  serviceName!: string;

  @Prop()
  serviceLocation!: string;

  @Prop({ default: false })
  isBookingCancelled!: boolean;

  get selectedSlotDate() {
    if (this.booking) {
      return detailedDateWithDay(new Date(this.booking.start).toISOString(), this.$t("locale").toString());
    }

    return "";
  }

  get selectedSlotStartTime() {
    if (this.booking) {
      const from = formatHoursAndMinutes(new Date(this.booking.start));

      const to = formatHoursAndMinutes(new Date(this.booking.end));
      return this.$t("bookingForm.common.slot", { from, to });
    }

    return "";
  }

  cancel() {
    this.$emit("click");
  }
}
</script>
<style scoped>
.scrollable-content {
  overflow-y: auto;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
